<template>
  <div>
    <TheHeaderLg @search="search" :is-search-open="isSearchOpen" :search-result="searchResult" :menus="menuItems" :loading="loading"/>
    <TheHeaderMd @search="search" :is-search-open="isSearchOpen" :search-result="searchResult" :menus="menuItems" :loading="loading"/>
  </div>
</template>

<script>
import TheHeaderMd from './TheHeaderMd'
import TheHeaderLg from './TheHeaderLg'
import { mapGetters } from 'vuex'
import MenuResource from '../../../../api/menuResource'

const menuResource = new MenuResource()

export default {
  name: 'TheHeader',

  components: { TheHeaderMd, TheHeaderLg },

  computed: {
    ...mapGetters({
      menuItems: 'navigation/items',
      loading: 'navigation/loading',
      user: 'auth/user'
    })
  },

  mounted () {
  

    if (!this.menuItems && !this.loading) {
      this.loadMenus()
      this.loadPermissions()
    }

    window.addEventListener('click', () => {
      this.isSearchOpen = false
    })
  },

  methods: {
    loadPermissions () {
      this.$store.dispatch('navigation/loading', true)

      menuResource.permissions()
        .then(response => {
          this.$store.dispatch('navigation/setPermissions', response.data)
 
        })
        .finally(() => {
          this.$store.dispatch('navigation/loading', false)
        })
    },

    loadMenus () {
      this.$store.dispatch('navigation/loading', true)

      menuResource.menus()
        .then(response => {
          this.$store.dispatch('navigation/setItems', response.data)
         
        })
        .finally(() => {
          this.$store.dispatch('navigation/loading', false)
        })

        menuResource.pageButtonsPermissions()
        .then(response => {

        
          this.$store.dispatch('navigation/setPageButtonsPermissions', response.data)
         
        })
        .finally(() => {
          this.$store.dispatch('navigation/loading', false)
        })




         







    },

    search (keyword) {
      menuResource.search(keyword)
        .then(response => {
          this.searchResult = response.data.data
        })

      this.openSearchDropdown()
    },

    openSearchDropdown () {
      this.isSearchOpen = true
    },

    closeSearchDropdown () {
      this.isSearchOpen = false
      this.searchResult = []
    }
  },

  data () {
    return {
      isSearchOpen: false,
      searchResult: []
    }
  }
}
</script>

<style scoped>

</style>
